import React from 'react';

import { StyledInputField } from './inputField.style';

const InputField = (props) => {
  const {
    error = false,
    sizevalue = 'big',
    disabled = false,
    errorText = '',
    isError = false,
    ...otherProps
  } = props;

  return (
    <div style={{ position: 'relative' }}>
      <StyledInputField sizevalue={sizevalue} {...otherProps} disabled={disabled} error={error} />
      {isError && (
        <span
          style={{
            position: 'absolute',
            left: '10px',
            bottom: '-19px',
            fontSize: '14px',
            zIndex: '1',
            maxWidth: '320px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: 'red',
          }}
        >
          {errorText}
        </span>
      )}
    </div>
  );
};

export default InputField;
